module.exports = __webpack_public_path__ + "img/vertical-logo.fac466b9.svg";